import type { PrintColorPreview } from "./printExportTypes";

type PrintColorPreviewGridProps = {
  colorPreview: PrintColorPreview[];
};

export function PrintColorPreviewGrid({ colorPreview }: PrintColorPreviewGridProps) {
  return (
    <div className="grid grid-cols-5 gap-2">
      {colorPreview.map((color) => (
        <div key={`${color.source}-${color.output}`} className="flex flex-col gap-1">
          <div className="grid grid-cols-2 overflow-hidden rounded border border-[rgba(74,58,31,0.14)]">
            <span className="h-5" style={{ backgroundColor: color.source }} />
            <span className="h-5" style={{ backgroundColor: color.output }} />
          </div>
          <span className="truncate text-[9px] font-semibold text-[#6c5b3d]">{color.label}</span>
        </div>
      ))}
    </div>
  );
}
